import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './components/AdminLogin';
import PartnerLogin from './components/PartnerLogin';
import WelcomePage from './components/WelcomePage';
import AdminDashboard from './components/AdminDashboard';
import GeneralLoanHome from './components/GL/GeneralLoanHome';
import GeneralLoan from './components/GL/GeneralLoan';
import LoanReciever from './components/GL/LoanReciever';
import LoanLedger from './components/GL/LoanLedger';
import LoanReport from './components/GL/LoanReport';
import PartnerwiseReport from './components/GL/PartnerwiseReport';
import LoanPayment from './components/GL/LoanPayment';
import MonthlyCashbook from './components/GL/MonthlyCashbook';
import GeneralLoanDueReport from './components/GL/GeneralLoanDueReport';
import GeneralLoanPartnerwiseDueReport from './components/GL/GeneralLoanPartnerwiseDueReport';
import 'bootstrap/dist/css/bootstrap.min.css';
import CDLoanHome from './components/CD/CDLoanHome';
import CDLoan from './components/CD/CDLoan';
import CDLoanReciever from './components/CD/CDLoanReciever';
import CDLoanPayment from './components/CD/CDLoanPayment';
import CDLoanLedger from './components/CD/CDLoanLedger';
import CDLoanReport from './components/CD/CDLoanReport';
import CDLoanPartnerwiseReport from './components/CD/CDLoanPartnerwiseReport';
import CDLoanDueReport from './components/CD/CDLoanDueReport';
import CDLoanPartnerwiseDueReport from './components/CD/CDLoanPartnerwiseDueReport';
import TBDLoanHome from './components/TBD/TBDLoanHome';
import TBDLoan from './components/TBD/TBDLoan';
import TBDLoanLedger from './components/TBD/TBDLoanLedger';
import TBDLoanReciever from './components/TBD/TBDLoanReciever';
import TBDLoanPayment from './components/TBD/TBDLoanPayment';
import TBDLoanReport from './components/TBD/TBDLoanReport';
import TBDLoanPartnerwiseReport from './components/TBD/TBDLoanPartnerwiseReport';
import TBDLoanDueReport from './components/TBD/TBDLoanDueReport';
import TBDLoanPartnerwiseDueReport from './components/TBD/TBDLoanPartnerwiseDueReport';
import ExpenseManager from './components/AdminDashboard/ExpenseManager';
import BalanceEnquiry from './components/AdminDashboard/BalanceEnquiry';
import AdminDailyCashbook from './components/AdminDashboard/AdminDailyCashbook';
import AssistantRegistrar from './components/AdminDashboard/AssistantRegistrar';
import SheetPage from './components/AdminDashboard/SheetPage';
import CallInfo from './components/AdminDashboard/CallInfo';
import PimgyHome from './components/Pimgy/PimgyHome';
import FDHome from './components/FD/FDHome';
import PartnerDashboard from './components/PartnerDashboard/PartnerDashboard';
import PartnerMeetingDisplay from './components/PartnerDashboard/PartnerMeetingDisplay';
import FinanceAddCredit from './components/PartnerDashboard/FinanceAddCredit';
import ExcelAccount from './components/PartnerDashboard/ExcelAccount';

import PartnerMeeting from './components/PartnerDashboard/PartnerMeeting';
import PartnerAccount from './components/PartnerDashboard/PartnerAccount';
import SecondaryBalanceEnquiry from './components/PartnerDashboard/SecondaryBalanceEnquiry';
import DailyCashbook from './components/PartnerDashboard/DailyCashbook';
import FinanceMeeting from './components/PartnerDashboard/FinanceMeeting';
const App = () => {
  // Add keyboard shortcut listener for PartnerLogin
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.key === 'm') {
        window.location.href = '/partner-login'; // Redi-+-++++++
        // -rect to PartnerLogin on Ctrl+^
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress); // Cleanup on component unmount
    };
  }, []);

  return (
    <Routes>
      {/* Redirect from "/" to "/WelcomePage" */}
      <Route path="/" element={<Navigate to="/WelcomePage" replace />} />

      {/* Welcome Page Route */}
      <Route path="/WelcomePage" element={<WelcomePage />} />

      {/* Admin & Partner Login Routes */}
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/partner-login" element={<PartnerLogin />} />

      {/* Admin Dashboard - Protected */}
      <Route path="/admin-dashboard/*" element={
        <ProtectedRoute requireAdmin={true}>
          <AdminDashboard />
        </ProtectedRoute>
      } />

      {/* General Loan Routes - Protected (Admin only) */}
      <Route path="/general-loan" element={
        <ProtectedRoute requireAdmin={true}>
          <GeneralLoanHome />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/new" element={
        <ProtectedRoute requireAdmin={true}>
          <GeneralLoan />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/receiver" element={
        <ProtectedRoute requireAdmin={true}>
          <LoanReciever />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/receiver/loan-payment/:type/:id" element={
        <ProtectedRoute requireAdmin={true}>
          <LoanPayment />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/ledger" element={
        <ProtectedRoute requireAdmin={true}>
          <LoanLedger />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/reports" element={
        <ProtectedRoute requireAdmin={true}>
          <LoanReport />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/partnerwise-report" element={
        <ProtectedRoute requireAdmin={true}>
          <PartnerwiseReport />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/monthly-cashbook" element={
        <ProtectedRoute requireAdmin={true}>
          <MonthlyCashbook />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <GeneralLoanDueReport />
        </ProtectedRoute>
      } />
      <Route path="/general-loan/partnerwise-due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <GeneralLoanPartnerwiseDueReport />
        </ProtectedRoute>
      } />

      {/* CD Loan Routes - Protected (Admin only) */}
      <Route path="/cd-loan" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanHome />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/new" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoan />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/receiver" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanReciever />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/receiver/cd-loan-payment/:type/:id" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanPayment />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/ledger" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanLedger />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/reports" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanReport />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/partnerwise-report" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanPartnerwiseReport />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanDueReport />
        </ProtectedRoute>
      } />
      <Route path="/cd-loan/partnerwise-due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <CDLoanPartnerwiseDueReport />
        </ProtectedRoute>
      } />

      {/* TBD Loan Routes - Protected (Admin only) */}
      <Route path="/tbd-loan" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanHome />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/new" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoan />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/receiver" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanReciever />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/receiver/tbd-loan-payment/:type/:id" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanPayment />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/ledger" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanLedger />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/reports" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanReport />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/partnerwise-report" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanPartnerwiseReport />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanDueReport />
        </ProtectedRoute>
      } />
      <Route path="/tbd-loan/partnerwise-due-report" element={
        <ProtectedRoute requireAdmin={true}>
          <TBDLoanPartnerwiseDueReport />
        </ProtectedRoute>
      } />

      {/* Expense Manager Route - Protected (Admin only) */}
      <Route path="/expense-manager" element={
        <ProtectedRoute requireAdmin={true}>
          <ExpenseManager />
        </ProtectedRoute>
      } />

      {/* Balance Enquiry Route - Protected (Admin only) */}
      <Route path="/balance-enquiry" element={
        <ProtectedRoute requireAdmin={true}>
          <BalanceEnquiry />
        </ProtectedRoute>
      } />

      {/* Daily Cashbook Route - Protected (Admin only) */}
      <Route path="/daily-cashbook" element={
        <ProtectedRoute requireAdmin={true}>
          <AdminDailyCashbook />
        </ProtectedRoute>
      } />

      {/* Assistant Registrar Route - Protected (Admin only) */}
      <Route path="/assistant-registrar" element={
        <ProtectedRoute requireAdmin={true}>
          <AssistantRegistrar />
        </ProtectedRoute>
      } />

      {/* Call Info Route - Protected (Admin only) */}
      <Route path="/call-info" element={
        <ProtectedRoute requireAdmin={true}>
          <CallInfo />
        </ProtectedRoute>
      } />

      {/* Sheet Page Route - Protected (Admin only) */}
      <Route path="/sheets" element={
        <ProtectedRoute requireAdmin={true}>
          <SheetPage />
        </ProtectedRoute>
      } />

      {/* Pigmy Collection Routes - Protected (Admin only) */}
      <Route path="/pigmy-collection" element={
        <ProtectedRoute requireAdmin={true}>
          <PimgyHome />
        </ProtectedRoute>
      } />
      <Route path="/pigmy-collection/*" element={
        <ProtectedRoute requireAdmin={true}>
          <PimgyHome />
        </ProtectedRoute>
      } />

      {/* FD Component Routes - Protected (Admin only) */}
      <Route path="/fd" element={
        <ProtectedRoute requireAdmin={true}>
          <FDHome />
        </ProtectedRoute>
      } />
      <Route path="/fd/*" element={
        <ProtectedRoute requireAdmin={true}>
          <FDHome />
        </ProtectedRoute>
      } />

      {/* Partner Dashboard Routes - Protected (Partner only) */}
      <Route path="/partner-dashboard" element={
        <ProtectedRoute requirePartner={true}>
          <PartnerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/partner-meeting-display" element={
        <ProtectedRoute requirePartner={true}>
          <PartnerMeetingDisplay />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/partner-account" element={
        <ProtectedRoute requirePartner={true}>
          <PartnerAccount />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/secondary-balance-enquiry" element={
        <ProtectedRoute requirePartner={true}>
          <SecondaryBalanceEnquiry />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/finance-add-credit" element={
        <ProtectedRoute requirePartner={true}>
          <FinanceAddCredit />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/excel-account" element={
        <ProtectedRoute requirePartner={true}>
          <ExcelAccount />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/partner-meeting" element={
        <ProtectedRoute requirePartner={true}>
          <PartnerMeeting />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/finance-meeting" element={
        <ProtectedRoute requirePartner={true}>
          <FinanceMeeting />
        </ProtectedRoute>
      } />
      <Route path="/partner-dashboard/daily-cashbook" element={
        <ProtectedRoute requirePartner={true}>
          <DailyCashbook />
        </ProtectedRoute>
      } />
      {/* Catch-all Route */}
      <Route path="*" element={<h1>404 - Page Not Found</h1>} />
    </Routes>
  );
};

const WrappedApp = () => (
  <Router>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Router>
);

export default WrappedApp;
